// extracted by mini-css-extract-plugin
module.exports = {"instructions":"GameInstructions_instructions__N63-j","picture":"GameInstructions_picture__2LBm6"};